
import React from "react";
import { useState, useEffect } from 'react';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpot, getSpotsList } from "../../../../store/selectors.js";

//created components
import SelectLieu from '../../components/selectlieu/SelectLieu.jsx'
import PeriodPicker from '../../components/periodpicker/PeriodPicker.jsx'
import ButtonValidStep1 from '../../components/buttonValid/ButtonValidStep1.jsx'
import DisplayDuree from '../../components/displayduree/DisplayDuree.jsx'
import HeaderStep from "../../../../commons/headerstep/HeaderStep.jsx";
import AdresseLivraison from "../../components/adresselivraison/AdresseLivraison.jsx";




//import google map component
import GMap from "../../../../components/gmap/GMap.jsx";

//MUI list components:
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InfoIcon from '@mui/icons-material/Info';

/* let listSpots = [];
axios.get(baseURL + "/spot").then((response) => {
    listSpots = [].concat(response.data);

}); */

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function StepOne() { // component to manage the first step of shopping : choosing place and time
    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : language
    const idSpot = useSelector(getIdSpot); //global state : id of the selected spot
    const listSpots = useSelector(getSpotsList); //global state : id of the selected spot
    let infosSpot = "";
    let myCenter = {}; //center of the google map (set dynamically by selected spot)

    if (idSpot > 0) { //prepare spot informations
        let currentSpot = listSpots.filter((spot) => spot.id_spot === idSpot);
        infosSpot += currentSpot[0].nom_spot;
        infosSpot += " - " + currentSpot[0].adresse_spot;
        infosSpot += " " + currentSpot[0].cp_spot;
        infosSpot += " " + currentSpot[0].ville_spot;

        myCenter = { //set google map center
            lat: +currentSpot[0].gps_lat,
            lng: +currentSpot[0].gps_long
        };

    }


    //configure zone infos
    const listInfos = [];
    listInfos.push({
        titre: translator('Forfait 24 heures :', lang, "infosLoc1A"),
        infos: translator('Ce forfait est appliqué uniquement pour les locations se terminant au lendemain du retrait des vélos, à la même heure, soit 24 heures plus tard. Ce forfait ne peux pas être cumulé sur plusieurs journées.', lang, "infosLoc1B")
    })
    listInfos.push({
        titre: translator('Tarif demi-journée :', lang, "infosLoc2A"),
        infos: translator("Ce tarif s'applique pour les locations soit en matinée (dès l'ouverture) avant 13h, soit l'après midi après 13h (jusqu'à la fermeture).", lang, "infosLoc2B")
    })
    listInfos.push({
        titre: translator('Tarifs dégressifs :', lang, "infosLoc3A"),
        infos: translator("Les forfaits et tarifs de location sont dégressifs. Les tarifs affichés sont automatiquement calculés au plus bas, au prorata de vos durées de location.", lang, "infosLoc3B")
    })


    return (
        <div>
            {/* custumizable header component : */}
            <HeaderStep step={1} title={translator("Lieu / Durée de location", lang, "headerStep1")} custom={""} />


            {/*  "main" Div */}
            <div className="step1">

                <div className="step1-lieu-periode">

                    <div className="step1-lieu">
                        <SelectLieu listSpots={listSpots} /> {/* MUI select component, filled with spots from DB */}
                        <p>{infosSpot}</p> {/* spot infos */}
                        {idSpot > 0 && idSpot < 99 ? <GMap focus={myCenter} className="map-google" /> : null} {/* show map when a spot is selected */}
                        {idSpot === 99 ? <AdresseLivraison /> : null /* display form and alert for livraison */}
                    </div>

                    <div className="step1-periode">
                        <PeriodPicker activate={(idSpot > 0)} managerMode={false} /> {/*  datepicker disbled if no spot selected */}

                        <DisplayDuree />

                    </div>

                </div>
                <div>
                    <ButtonValidStep1 idSpot={idSpot} />
                </div>

                <div className="step1-infos"> {/* general infos about prices and formules */}
                    <List dense={true}>
                        {
                            listInfos.map((infos, index) =>
                                <ListItem key={index}>
                                    <ListItemIcon>
                                        <InfoIcon className="icon-info" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={infos.titre}
                                        secondary={infos.infos}
                                    />
                                </ListItem>
                            )
                        }
                    </List>
                </div>

            </div>

        </div>
    )
}




export default StepOne